import { FC } from 'react';

import CoatingFormulationComponentListing from 'components/main/CoatingFormulationComponent';

const CoatingFormulationComponent: FC = () => <CoatingFormulationComponentListing />;

export default CoatingFormulationComponent;
